import styled from 'styled-components';

export const Wrapper = styled.div`
  display: block;
`;

export const PreviewWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const FileCard = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid ${props => props.theme.color.wfGrey200};
  font-size: 0.875em;
  font-weight: 600;
  color: ${props => props.theme.color.primary};
  margin: ${props => (props.last ? '5px 0 15px 0' : '5px 0 5px 0')};
  padding: 12px 10px;
  height: 42px;
  border-radius: 2px;
`;

const Count = styled.span`
  color: ${props => props.theme.color.wfGrey500};
`;

export const Size = styled(Count)`
  font-weight: 400;
`;
